<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'bikeshop.users.edit_working_hours' | translate }} - {{ dayOfWeek() }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row margin-top-8">
    <div class="col-md-12">
      <h6>{{ Name }}</h6>
    </div>
  </div>
  <div class="row margin-top-16">
    <div class="col-md-12">
      <div>{{ 'bikeshop.users.shift_start' | translate }}</div>
      <p-dropdown [options]="workingHours" [(ngModel)]="Technician[dayStart]" placeholder="{{ 'bikeshop.users.start_time' | translate }}"></p-dropdown>
    </div>
  </div>
  <div class="row margin-top-8" >
    <div class="col-md-12">
      <div>{{ 'bikeshop.users.shift_edit' | translate }}</div>
      <p-dropdown [options]="workingHours" [(ngModel)]="Technician[dayEnd]" placeholder="{{ 'bikeshop.users.end_time' | translate }}"></p-dropdown>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-md-4">
      <button pButton class="full-width alternate" label="{{ 'bikeshop.general.delete' | translate }}" (click)="delete()"></button>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <button pButton class="full-width" (click)="save()" label="{{ 'bikeshop.general.save' | translate }}"></button>
    </div>
  </div>
</div>

<p-confirmDialog key="user_key" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>